// these breakpoints represent the outer boundary (max-width) for these devices
export const breakpoints = {
  smallMobile: 376,
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
};
